import React, {useEffect}  from 'react';

import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import {A} from 'views/AppElements';

const DesignerFAQ = () => {
    return <div id="designerFAQ">
        <h2>FAQ For Designers</h2>

        <ul>
            <li>
                <h3>How do I join as a designer?</h3>
                <p>- Sign Up and start uploading your designs <A href="design/submit" target="_blank">here</A>.</p>
            </li>
            <li>
                <h3>Can I upload same design on T-Shirt, Hoodie, PhotoFrame?</h3>
                <p>- Yes, you can. Multiple Uploads of same design on various merchandise are allowed.</p>
            </li>

            <li>
                <h3>Do I get commission on design or on sales?</h3>
                <p>- The commission is based on sales. Your one design may make multiple sales or no sales at all. So you'll be paid according to the number of orders made by a particular design.</p>
            </li>
            <li>
                <h3>How much commission do I get?</h3>
                <p>- The commission amount varies per merchandise. On T-Shirt, the commission amount ranges from Rs. 50-100, on Hoodies it starts at Rs. 100 and on PhotoFrame, it starts at Rs. 250.</p>
            </li>
            <li>
                <h3>On which format should I submit my designs?</h3>
                <p>- We accept <b>.jpg</b> format.</p>
            </li>
            <li id="tshirtDesignLimitation">
                <h3>What kind of designs are supported on Tshirts?</h3>
                <p>- In case of White Tshirts, any colorful designs can be printed on a A4 size canvas. Large images such as A3 designs are not supported.
                    <br />
                    <s>- In case of Black Tshirts, however, only mono-color or at most 2 colors are supported. Only Flat Designs (designs without much details) such as Text and Geometrical figures are supported. Visit <A href="/shop/tshirt" target="_blank">T-Shirt Shop</A> to view all supported designs on a Black T-Shirt.</s>
                    <br />
                    - We now support multi-color prints in Black T-Shirt too.
                </p>
            </li>
            <li id="hoodiesDesignLimitation">
                <h3>What kind of designs are supported on Hoodies?</h3>
                <p>- Same as Black Tshirt. Read above to know limitations for Black Tshirts.</p>
            </li>
            <li>
                <h3>Do you have any Tutorials on how to upload designs?</h3>
                <p>- Yes, we do. You can visit our <A href={AppConstants.YT_CHANNEL}>Youtube Page</A> to view all tutorials.</p>
            </li>
            <li id="designPendingApproval">
                <h3>Why is my Design Pending Approval?</h3>
                <p>- Our moderator takes a period of max 1 week to approve your design. But you must also email a 300 resolution A4 size .png version (background less) of your design only (not the one with Tshirt or Hoodie) to <b>setocanvas@gmail.com</b>. Only after the design file is available, our moderator can then approve your design. And also make sure to meet the above mentioned design guidelines for Tshirt and Hoodies. Your design won't be approved, if it does not meet those guidelines.
                <br />
                <i>Check the following image file as an example: <A href="https://drive.google.com/file/d/1tRj0Yo0kb7N4Vl4sA_MGw7IGh8ifXU5c/view?usp=sharing">Sample PNG File</A></i>
                </p>
            </li>
        </ul>
    </div>
}

const PhotographerFAQ = () => {
    return (<div id="photographerFAQ">
        <h2>FAQ For Photographers</h2>
        <ul>
            <li>
                <h3>How do I join as a photographer?</h3>
                <p>- Sign Up and start uploading your photographs <A href="design/submit">here</A></p>
            </li>
            <li>
                <h3>What kind of photographs can I upload?</h3>
                <p>- There is no specific kind of photos that we require but a visually good looking photos are encouraged to upload since it will motivate our users to order.</p>
            </li>
            <li>
                <h3>How many photos can I upload?</h3>
                <p>- There is no limit to the number of photos you can upload.</p>
            </li>
            <li>
                <h3>How much commission will I receive?</h3>
                <p>- The commission is based on sales. On every order your photograph frame, you'll receive certain commission starting at Rs. 250 for the smallest size frame. The commission per different frame size varies and you can see it in your dashboard, when an order is made.</p>
            </li>
            <li>
                <h3>Can I use watermarks on the photos?</h3>
                <p>- If you are using a watermark, do make sure it is minimal and doesn't hamper the aestheic of the image. Additionally we don't have control over which photograph gets sold and its purely the decision of the buyer so please make sure that aspect is taken care of.</p>
            </li>
            <li>
                <h3>On which format should I submit my photos?</h3>
                <p>- We accept <b>.jpg</b> format.</p>
            </li>
            <li>
                <h3>Do you have any Tutorials on how to upload designs?</h3>
                <p>- Yes, we do. You can watch this <A href="https://www.youtube.com/watch?v=0APtVvBBUpI">Video Tutorial</A>  to learn about it.</p>
            </li>
            <li id="photographPendingApproval">
                <h3>Why is my Photograph Pending Approval?</h3>
                <p>- Our moderator takes a period of max 1 week to approve your photograph. But you must also email your original photograph image to <b>setocanvas@gmail.com</b>. Only after the image file is available, our moderator can then approve your photograph. 
                </p>
            </li>
        </ul>
    </div>)
}

const FAQ = () => {

    useEffect(() => {
        AppUtil.scrollToHashTagIfAny(45);
    }, []);
    
    return (<SetoCanvasPage id="faqPage" title={"Seto Canvas Frequently Asked Question"}>
            <DesignerFAQ />
            <PhotographerFAQ />
    </SetoCanvasPage>)
};

export default FAQ;


// WEBPACK FOOTER //
// ./src/pages/docs/FAQ.js